import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StatisticState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: StatisticState = {
  pushStatisticDetail: [],
  pushStatisticDetailFlag: undefined,
  pushStatisticGroup: [],
  pushMessageCount: 0,
  pushGroupings: {
    pushGroupBy: [
      'hour',
      'day',
      'week',
      'month',
    ],
    pushGroupByOptionally: [
      'partner',
      'application',
      'os',
      'template_id',
      'bulk_id',
      'broker_account_login',
      'message_type',
    ],
    pushGroupIncoming: [

    ],
  },
  pushSubscribers: undefined,
  pushHistories: undefined,
};

export const pushStatistic: Module<StatisticState, RootState> = {
  state,
  getters,
  actions,
  mutations
};
